import React, { useEffect } from "react";
import { useStateIfMounted } from "use-state-if-mounted";
import mqtt_topics from "../../../mqtt/mqtt_topics";
import "./../../../css/app.css";
import useCheckMobileScreen from "./../readingView/useCheckMobileScreen";

const Normal = (props) => {
  const mac = mqtt_topics.choosenmac;
  const [state, setState] = useStateIfMounted({
    value: 0,
    unit: props.unit, //" --- "
    title: props.title, //"Normal UI"
    step: props.step,
    disabled: false, //if returned value == na set to false
    progress: false,
    acc: props.acc,
  });
  const [lastReceivedValue, setLastReceivedValue] = useStateIfMounted();
  const target_live_reading_topic =
    mqtt_topics.fixed_topic_part +
    mac +
    "/" +
    props.category +
    "/" +
    props.subcategory +
    "/" +
    props.title; //+mqtt_topics.Readings_topic +state.title

  function listenforlivedata() {
    props.mqttClient.subscribe(target_live_reading_topic);
    props.mqttClient.on("message", handleMqttMessage);
  }

  function handleMqttMessage(topic, message) {
    if (topic == target_live_reading_topic) {
      try {
        // message is Buffer
        message = JSON.parse(message.toString());

        if (message.value.toLowerCase().toString() == "nv") {
          setState({
            ...state,
            disabled: true,
            progress: false,
          });
        } else {
          setState({
            ...state,
            value: message.value == undefined ? 0 : message.value,
            disabled: false,
            progress: false,
          });
          setLastReceivedValue(message.value == undefined ? 0 : message.value);
        }
      } catch (error) {
        //console.log(message);
      }
    }
  }

  useEffect(() => {
    listenforlivedata();
    /*new Masonry(".grid-container", {
      // Options for Masonry if needed
    });*/
  }, []);

  //when componenet unmount
  useEffect(
    () => () => {
      props.mqttClient.unsubscribe(target_live_reading_topic);
      props.mqttClient.removeListener("message", handleMqttMessage);
    },
    []
  );

  function setparameter(val) {
    if (!mqtt_topics.busy_Requesting_Data) {
      requestdata(val);
    } else {
      setTimeout(function () {
        requestdata(val);
      }, mqtt_topics.timeouttotrytorequestmqttdata); //wait 1 seconds
    }
  }

  function requestdata(val) {
    mqtt_topics.busy_Requesting_Data = true;
    props.mqttClient.publish(
      mqtt_topics.fixed_topic_part + mac + mqtt_topics.request_topic,
      JSON.stringify({
        param: props.category + "/" + props.subcategory + "/" + props.title,
        value: val == "" ? "0" : val.toString(),
      })
    );
    mqtt_topics.busy_Requesting_Data = false;
  }

  function enforceMinMax(el) {
    if (el.value != "") {
      if (parseFloat(el.value) <= parseFloat(el.min)) {
        el.value = el.min;
      }
      if (parseFloat(el.value) >= parseFloat(el.max)) {
        el.value = el.max;
      }
    }
  }
  return (
    <div
      className="grid-item "
      style={{ display: state.disabled ? "none" : "block" }}
    >
      <div style={{ display: state.progress ? "none" : "block" }}>
        {state.title}
        &nbsp;
        <input
          type="number"
          value={state.value == "NV" ? "0" : state.value}
          disabled={!state.acc}
          min={props.min}
          max={props.max}
          step={state.step == undefined ? "1" : state.step}
          onChange={(e) => {
            setState({
              ...state,
              value: e.target.value,
            });
          }}
          onBlur={(e) => {
            if (e.target.value != lastReceivedValue) {
              enforceMinMax(e.target);
              setparameter(e.target.value);
              setState({
                ...state,
                progress: true,
              });
            }
          }}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              if (e.target.value != lastReceivedValue) {
                enforceMinMax(e.target);
                setparameter(e.target.value);
                setState({
                  ...state,
                  progress: true,
                });
              }
            }
          }}
          className="normalparamtersinput"
        />
        <strong style={{ fontSize: useCheckMobileScreen() ? "6px" : "10px" }}>
          {state.unit == undefined ? "" : " " + state.unit + ""}
        </strong>
      </div>
      <div
        className="spinner-border text-primary"
        style={{ display: state.progress ? "block" : "none" }}
      ></div>
    </div>
  );
};

export default Normal;
